import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import AppLogo from '@/components/AppLogo';

/**
 * Global site header — consistent primary navigation on every content page,
 * present in the prerendered HTML so crawlers see a clear site structure and
 * every key page is reachable within one click. (Publisher-readiness Phase 2.1)
 */
const NAV = [
  { to: '/', label: 'Home' },
  { to: '/airports', label: 'Airports' },
  { to: '/live', label: 'Live' },
  { to: '/insights', label: 'Insights' },
  { to: '/blog', label: 'Blog' },
  { to: '/about', label: 'About' },
];

export default function SiteHeader() {
  const { pathname } = useLocation();
  const isActive = (to) =>
    to === '/' ? pathname === '/' : pathname === to || pathname.startsWith(to + '/');

  return (
    <header
      data-testid="site-header"
      className="bg-white/95 backdrop-blur border-b border-slate-200 sticky top-0 z-50"
    >
      <div className="container mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-14 sm:h-16 gap-4">
          <Link
            to="/"
            data-testid="site-header-logo"
            className="flex items-center gap-2.5 hover:opacity-80 transition-opacity min-w-0"
          >
            <AppLogo size={32} className="flex-shrink-0" />
            <span className="heading text-[13px] sm:text-base font-semibold tracking-tight text-slate-900 whitespace-nowrap">
              How Busy Is My Airport
            </span>
          </Link>

          <nav
            data-testid="site-header-nav"
            className="flex items-center gap-1 sm:gap-2 overflow-x-auto no-scrollbar -mr-2 pr-2"
          >
            {NAV.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                data-testid={`nav-${item.label.toLowerCase()}`}
                className={`px-2.5 sm:px-3 py-1.5 rounded-md text-[13px] sm:text-sm font-medium whitespace-nowrap transition-colors ${
                  isActive(item.to)
                    ? 'bg-blue-50 text-blue-700'
                    : 'text-slate-600 hover:text-blue-600 hover:bg-slate-50'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
      </div>
    </header>
  );
}
